import { Box, Divider, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { HistoryMenuOption } from "src/utils/userRequestHistoryUi";

interface HistoryMenuMainProps {
  options: HistoryMenuOption[];
  onSelectEndpoint: (key: HistoryMenuOption["key"]) => void;
}

/** Endpoint list — same layout as HelpMenuMain, inverted colors (black bg / white text). */
export const HistoryMenuMain = ({ options, onSelectEndpoint }: HistoryMenuMainProps) => {
  if (options.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography sx={{ fontSize: "15px", color: "#ffffff", fontWeight: "bold" }}>
          No history found for this league.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      sx={{ p: 2 }}
      gap={0}
    >
      {options.map((item, index) => (
        <Box key={item.key} sx={{ width: "100%" }}>
          <Box
            onClick={() => onSelectEndpoint(item.key)}
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              cursor: "pointer",
              py: 1.5,
              px: 1,
              width: "100%",
            }}
          >
            <Typography
              variant="h6"
              color="#ffffff"
              textAlign="left"
              sx={{
                fontSize: "15px",
                fontWeight: "medium",
              }}
            >
              {item.label}
            </Typography>
            <ChevronRightIcon
              sx={{
                color: "#ffffff",
                fontSize: "24px",
              }}
            />
          </Box>
          {index < options.length - 1 && (
            <Divider
              sx={{
                width: "98%",
                height: "1.5px",
                bgcolor: "rgba(255, 255, 255, 0.3)",
                my: 0,
                mx: "auto",
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
};
